import { render, staticRenderFns } from "./irsaliye.vue?vue&type=template&id=a9e1baee"
import script from "./irsaliye.vue?vue&type=script&lang=js"
export * from "./irsaliye.vue?vue&type=script&lang=js"
import style0 from "./irsaliye.vue?vue&type=style&index=0&id=a9e1baee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports